module.exports = __webpack_public_path__ + "img/saturn-bg.87b374ad.jpg";